import React from 'react'
import clsx from 'clsx'
import { menuItemParams } from '../../../types'
import Child from './Child'
import Parent from './Parent'
import style from './style.module.scss'

type SubMenuMainHeaderParams = {
    subMenu: menuItemParams[]
    isActive: boolean
}

const SubMenuMainHeader: React.FC<SubMenuMainHeaderParams> = ({ subMenu, isActive }) => {
    return (
        <nav className={clsx(style.submenu, isActive && style.active)}>
            <div className={style.border} />
            <ul>
                {subMenu.map((item, index) => (
                    <React.Fragment key={index}>
                        <li>
                            {item.url === '#container' ? (
                                item.children.length > 0 &&
                                item.children.map((children, i) => (
                                    <div className={style.container} key={i}>
                                        <Parent item={children} />
                                        <Child item={children} />
                                    </div>
                                ))
                            ) : (
                                <>
                                    <Parent item={item} />
                                    <Child item={item} />
                                </>
                            )}
                        </li>
                        {index < subMenu.length - 1 && <div className={style.dashed} />}
                    </React.Fragment>
                ))}
            </ul>
        </nav>
    )
}

export default SubMenuMainHeader
